import * as React from "react";
import { Helmet } from "react-helmet";

const logo: string = require("../images/logo.png");

export interface MetaTagsProps {
  title: string;
  image?: string;
  url?: string;
  ogType?: string;
  twitterCardType?: string;
  description?: string;
  children?: React.ReactChild[] | React.ReactChild;
}

const getImageFullUrl = image => {
  if (image.indexOf("http") === 0) {
    return image;
  }
  return `${location.protocol}://${location.hostname}${image}`;
};

const MetaTags = ({
  ogType = "website",
  twitterCardType = "website",
  url = window.location.href,
  image = logo,
  ...props,
}: MetaTagsProps) => (
  <Helmet>
    <title>{props.title}</title>
    <meta property="og:title" content={props.title} />
    <meta property="og:type" content={ogType} />
    <meta property="og:url" content={url} />
    <meta property="og:image" content={getImageFullUrl(image)} />
    <meta name="twitter:card" content={twitterCardType} />
    <meta name="twitter:title" content={props.title} />
    <meta name="twitter:image" content={getImageFullUrl(image)} />

    {props.description && (
      <meta property="og:description" content={props.description} />
    )}
    {props.description && (
      <meta name="twitter:description" content={props.description} />
    )}
    {props.description && (
      <meta name="description" content={props.description} />
    )}
    {props.children}
  </Helmet>
);

export default MetaTags;



// WEBPACK FOOTER //
// ./src/head/MetaTags.tsx